import { Injectable } from '@angular/core';
import { OrganizationService } from './organization.service';
import * as Parse from 'parse';

@Injectable()
export class VideoService {

    constructor(private orgService: OrganizationService) {
    }

    fetchVideosForProperty(property: Parse.Object) {
        const query: Parse.Query = new Parse.Query('Video');

        query.equalTo('property', property);
        query.equalTo('organization', this.orgService.organization);
        query.descending('createdAt');

        return query.find();
    }

    async createVideo(file: File, property: Parse.Object) {
        const parseFile: Parse.File = new Parse.File(file.name.replace(/[^a-zA-Z0-9]/g,'_'), file);
        const video = new Parse.Object('Video');

        video.set('file', parseFile);
        video.set('name', file.name);
        video.set('property', property);
        video.set('type', file.type);

        return video.save();
    }
}
